import type { ReactNode } from "react";
import { LocaleProvider } from "@itaas/core/i18n/LocaleContext";
import { TenantProvider } from "@itaas/core/tenant/TenantContext";
import { SubscriptionProvider } from "@itaas/core/subscription/SubscriptionContext";
import { BillingAuthProvider } from "@/auth/BillingAuthProvider";
import { BillingDataProvider } from "@/billing/BillingDataProvider";

interface BillingProvidersProps {
  children: ReactNode;
}

export function BillingProviders({ children }: BillingProvidersProps) {
  return (
    <LocaleProvider>
      <BillingAuthProvider>
        <BillingDataProvider>
          <TenantProvider>
            <SubscriptionProvider>{children}</SubscriptionProvider>
          </TenantProvider>
        </BillingDataProvider>
      </BillingAuthProvider>
    </LocaleProvider>
  );
}
